import i18n from "@/components/I18n";
// 图表label
const CHAR_TYPE = {
  kols: i18n.t("baseInfo.kols"),
  posts: i18n.t("baseInfo.posts"),
  praises: i18n.t("baseInfo.zans"),
  followers: i18n.t("baseInfo.fansNum"),
  comments: i18n.t("baseInfo.comments"),
  reposts: i18n.t("baseInfo.reposts"),
};
// 图表label
const PIECHAR_TYPE = {
  posts: i18n.t("baseInfo.posts"), //"声量",
  interaction: i18n.t("baseInfo.interaction"),
  reposts: i18n.t("baseInfo.reposts"),
  comments: i18n.t("baseInfo.comments"),
  zans: i18n.t("baseInfo.zans"),
};

//平台类型
const PLANT_TYPE = {
  xhs: i18n.t("mainHead.platList_xhs"), //"声量",
  weibo: i18n.t("mainHead.platList_weibo"),
  douyin: i18n.t("mainHead.platList_douyin"),
};

// 原文链接地址
const POST_LINK = {
  xhs: "https://www.xiaohongshu.com/discovery/item/",
  weibo: "https://m.weibo.cn/status/",
  douyin: "https://www.douyin.com/video/",
};

export { CHAR_TYPE, PLANT_TYPE, PIECHAR_TYPE, POST_LINK };
